/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Payment,
    PaymentFromJSON,
    PaymentFromJSONTyped,
    PaymentToJSON,
} from './';

/**
 * 
 * @export
 * @interface PaymentDataFrame
 */
export interface PaymentDataFrame {
    /**
     * 
     * @type {number}
     * @memberof PaymentDataFrame
     */
    count: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDataFrame
     */
    offset: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentDataFrame
     */
    limit: number;
    /**
     * 
     * @type {Array<Payment>}
     * @memberof PaymentDataFrame
     */
    data: Array<Payment>;
}

export function PaymentDataFrameFromJSON(json: any): PaymentDataFrame {
    return PaymentDataFrameFromJSONTyped(json, false);
}

export function PaymentDataFrameFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentDataFrame {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'offset': json['offset'],
        'limit': json['limit'],
        'data': ((json['data'] as Array<any>).map(PaymentFromJSON)),
    };
}

export function PaymentDataFrameToJSON(value?: PaymentDataFrame | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'offset': value.offset,
        'limit': value.limit,
        'data': ((value.data as Array<any>).map(PaymentToJSON)),
    };
}


